export default "__VITE_ASSET__DZqMBTZj__"